import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

/** Full-size instrument photo with a one-line description. `item` = { name, src, alt, caption } or null. */
export default function InstrumentLightbox({ item, onClose }) {
  return (
    <Dialog open={!!item} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        data-testid="instrument-lightbox"
        className="max-w-3xl border-line/15 bg-surface p-0 sm:rounded-none [&>button]:right-3 [&>button]:top-3 [&>button]:rounded-full [&>button]:bg-[#0A0F1A]/80 [&>button]:p-1.5 [&>button]:text-white [&>button]:opacity-100 hover:[&>button]:bg-[#0A0F1A]"
      >
        {item && (
          <div className="corner-brackets">
            <div className="flex max-h-[70vh] items-center justify-center bg-white p-4">
              <img
                src={item.src}
                alt={item.alt}
                data-testid="instrument-lightbox-image"
                className="max-h-[62vh] w-auto max-w-full object-contain"
              />
            </div>
            <div className="border-t border-line/10 px-6 py-5">
              <p className="hud-label">{item.tag}</p>
              <DialogTitle className="mt-2 font-heading text-xl font-medium tracking-tight text-ink" data-testid="instrument-lightbox-title">
                {item.name}
              </DialogTitle>
              <DialogDescription className="mt-1.5 text-sm leading-relaxed text-body" data-testid="instrument-lightbox-caption">
                {item.caption}
              </DialogDescription>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
